import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { tableCellRender, handleNullValue } from "../util/tableUtils";

//       <Box sx={{ fontWeight: 600 }}>{props.label}</Box>

const DisplayField = (props) => (
  <Box m={0.5} mb="0.5em">
    <Typography variant="body2" display="block" style={{ fontWeight: "bold" }}>
      {props.label}
    </Typography>
    <Typography variant="caption" gutterBottom>
      {handleNullValue(props.value || "")}
    </Typography>
  </Box>
);

const DATETIME_FORMAT = process.env.REACT_APP_DATETIME_FORMAT;

export const ClaimDbDescription = (props) => {
  const { t } = useTranslation();
  const { claim } = props;

  return (
    <Box p={1}>
      <Box display="flex" mt="1em">
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("claims.claimCode")} value={claim.claimCode} />
        </Box>
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("claims.claimEventType")} value={claim.perilName} />
        </Box>
      </Box>
      <Box display="flex">
        <DisplayField label={t("claims.claimCause")} value={claim.claimCauseDescription} />
      </Box>
      <Box display="flex">
        <Box flex={1} mr="0.5em">
          <DisplayField
            label={t("claims.reportDate")}
            value={new Date(claim.claimReportDate).toLocaleDateString(DATETIME_FORMAT)}
          />
        </Box>
        <Box flex={1} mr="0.5em">
          <DisplayField
            label={t("claims.claimEventDate")}
            value={new Date(claim.claimEventDate).toLocaleDateString(DATETIME_FORMAT)}
          />
        </Box>
      </Box>
      <Box display="flex">
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("claims.claimAmount")} value={tableCellRender(claim.claimLoadTotalAmount)} />
        </Box>
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("claims.claimOutcome")} value={claim.claimOutcome} />
        </Box>
      </Box>

      <Box display="flex">
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("claims.claimEventCity")} value={claim.claimAddressCity} />
        </Box>
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("claims.claimEventCityCode")} value={claim.claimAddressCityCode} />
        </Box>
      </Box>

      <Box display="flex">
        <Box flex={1} mr="0.5em">
          <DisplayField
            label={t("claims.claimEventAddress")}
            value={`${claim.claimAddressStreetName ?? ""} ${claim.claimAddressBuildingNo ?? ""}`}
          />
        </Box>
      </Box>
    </Box>
  );
};
